import { InfoRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';

const AlertMessage = ({ children, align = "center" }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);



  return (
    <div className={cx(classes.container, align == "top" ? global.frjs : global.fracjs)}>
      <InfoRounded className={classes.infoIcon} />
      {children}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    border: "1px dashed #f50057",
    borderRadius: "8px",
    backgroundColor: "#fbd3d5",
    padding: "10px",
    height: "min-content",
    width: "100%",
    gap: "5px",
    overflow: "hidden",
  },
  infoIcon: {
    height: "20px",
    width: "20px",
    fill: "#f50057",
  }
});

export default AlertMessage;